import React from 'react';
import { css } from '@emotion/react';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

function WorkflowUserName(props: { name: string; isAccountWorker: boolean }) {
  if (!props.isAccountWorker) {
    return <>{props.name}</>;
  }

  return (
    <span
      css={css`
        display: inline-flex;
        align-items: center;
        gap: 6px;
      `}
    >
      {props.name}
      <Tooltip title="Created by an account worker">
        <Chip label="account" size="small" variant="outlined" />
      </Tooltip>
    </span>
  );
}

export default React.memo(WorkflowUserName);
